import axios from 'axios'
let Config = {}
let root = "";
if (process.env.NODE_ENV === "development") {
  Config = {
    API_PATH: '/'
  }
}

var ajax = axios.create({
  baseURL: Config.API_PATH,
  timeout: 60 * 60 * 1000,
  trimNull: false, // 是否去除空值
  withCredentials: true, // default
  needLoading: false, // 是否需要加载效果
  ignoreCode: false, // 是否忽略服务端的错误提示
  headers: {}
})

ajax.interceptors.request.use(function (config) {
  if (config.needLoading) {
    // loading.show
  }
  config.params = config.method === "get" || config.method === "delete" ? config.data || config.params : null
  config.data = config.method === "post" || config.method === "put" ? config.data || config.params : null
  if (config.trimNull && !(config.data instanceof window.FormData)) {
    let _data = Object.assign({}, config.data)
    isNull(_data)
    config.data = _data
  }
  return config
  function isNull(obj) {
    for (let [key, value] of Object.entries(obj)) {
      if (!value && typeof value !== 'number') {
        obj[key] = null
        return
      }
      if (typeof value === 'object' && !(value instanceof Date)) isNull(value)
    }
  }
}, function (error) {
  return Promise.reject(error)
})

ajax.interceptors.response.use(function (response) {
  if (response.config.needLoading) {
    // loading.hide
  }
  return response
}, function (error) {
  // loading.hide
  return Promise.reject(error)
})


ajax.get = function (url, reqParams = {}, configParams = {}) {
  return ajax({
    url: url,
    method: 'get',
    needLoading: configParams.needLoading,
    params: reqParams
  })
}
ajax.post = function (url, reqParams = {}, configParams = {}) {
  return ajax({
    url: url,
    method: 'post',
    needLoading: configParams.needLoading,
    data: reqParams
  })
}


export default ajax
